import React from 'react';
import { ArrowUturnLeftIcon, ArrowUturnRightIcon } from '@heroicons/react/24/outline';

const UndoRedo = ({ onUndo, onRedo, canUndo, canRedo }) => {
  return (
    <div className="te-undo-redo">
      <button
        onClick={onUndo}
        disabled={!canUndo}
        className="te-icon-btn"
        title="Undo (Cmd+Z)"
      >
        <ArrowUturnLeftIcon className="h-4 w-4" />
      </button>
      <button
        onClick={onRedo}
        disabled={!canRedo}
        className="te-icon-btn"
        title="Redo (Cmd+Shift+Z)"
      >
        <ArrowUturnRightIcon className="h-4 w-4" />
      </button>
    </div>
  );
};

export default UndoRedo;
